/* ENISSATI · Avant/Après compare slider — vanilla JS (no deps).
   Drag handle, touch swipe, click-to-jump, arrow keys. */
(function () {
  'use strict';

  function init(section) {
    var slider = section.querySelector('[data-aa-slider]');
    if (!slider) return;
    var before = slider.querySelector('[data-aa-before]');
    var divider = slider.querySelector('[data-aa-divider]');
    var handle = slider.querySelector('[data-aa-handle]');
    if (!before || !divider || !handle) return;

    var pct = 50; // current cursor position (0–100)
    var dragging = false;

    function setPosition(p) {
      pct = Math.max(0, Math.min(100, p));
      // Clip the AVANT image to the left portion only
      before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      divider.style.left = pct + '%';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', String(Math.round(pct)));
    }

    function pctFromEvent(ev) {
      var rect = slider.getBoundingClientRect();
      var x = (ev.touches && ev.touches[0] ? ev.touches[0].clientX : ev.clientX) - rect.left;
      return (x / rect.width) * 100;
    }

    function onDown(ev) {
      dragging = true;
      handle.classList.add('is-dragging');
      setPosition(pctFromEvent(ev));
      ev.preventDefault && ev.preventDefault();
    }
    function onMove(ev) {
      if (!dragging) return;
      setPosition(pctFromEvent(ev));
    }
    function onUp() {
      dragging = false;
      handle.classList.remove('is-dragging');
    }

    // Drag from anywhere on the slider
    slider.addEventListener('mousedown', onDown);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    slider.addEventListener('touchstart', onDown, { passive: false });
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', onUp);
    window.addEventListener('touchcancel', onUp);

    // Keyboard accessibility on handle
    handle.addEventListener('keydown', function (ev) {
      var step = ev.shiftKey ? 10 : 2;
      if (ev.key === 'ArrowLeft' || ev.key === 'ArrowDown') {
        setPosition(pct - step); ev.preventDefault();
      } else if (ev.key === 'ArrowRight' || ev.key === 'ArrowUp') {
        setPosition(pct + step); ev.preventDefault();
      } else if (ev.key === 'Home') {
        setPosition(0); ev.preventDefault();
      } else if (ev.key === 'End') {
        setPosition(100); ev.preventDefault();
      }
    });

    // Initial position
    setPosition(50);

    // Reset on window resize (no-op, but keeps things tidy)
    window.addEventListener('resize', function () { setPosition(pct); });
  }

  function boot() {
    document.querySelectorAll('[data-aa-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on Shopify editor section load
  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector && ev.target.querySelector('[data-aa-section]')) {
      ev.target.querySelectorAll('[data-aa-section]').forEach(init);
    } else if (ev.target && ev.target.matches && ev.target.matches('[data-aa-section]')) {
      init(ev.target);
    }
  });
})();
